import {createAsyncThunk} from "@reduxjs/toolkit";
import { axiosInstance } from "../../../utils/axios/requestInfo";
import { api } from "../../../resources/api";
import { getFamilyPurchaseHistory } from "../history/bitrixHistory";
import { fetchMyProfiles } from "../profileInfo/asyncActions";

export const fetchPurchaseHistory = createAsyncThunk<any>(
    "purchaseHistory/fetchPurchaseHistory",
    async (_, { getState, dispatch }) => {
        try {
            await dispatch(fetchMyProfiles()).unwrap();
            
            const state: any = getState();
            const myProfiles = state.getProfileInfo?.myProfiles || [];
            const partnerId = state.user?.partnerId;
            
            const partnerIds: string[] = [];
            const uniquePartnerIds = new Set<string>();
            
            if (partnerId) {
                uniquePartnerIds.add(String(partnerId));
            }
            
            myProfiles.forEach((profile: any) => {
                if (profile.partner_id) {
                    uniquePartnerIds.add(String(profile.partner_id));
                }
            });
            
            partnerIds.push(...Array.from(uniquePartnerIds));

            if (partnerIds.length === 0) {
                return [];
            }

            const historyData = await getFamilyPurchaseHistory(partnerIds);
            
            const processedHistory: any[] = [];
            
            if (historyData.rents && Array.isArray(historyData.rents)) {
                historyData.rents.forEach((rent: any) => {
                    const startTime = new Date(rent.startTime);
                    const endTime = new Date(rent.finishTime);
                    
                    processedHistory.push({
                        ...rent,
                        type: "rent",
                        id: `rent_${rent.courtId}_${rent.startTime}`,
                        date: rent.startTime,
                        finishTime: rent.finishTime,
                        time: startTime.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
                        time_to: endTime.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
                        hall: {
                            title: `Корт`,
                            id: rent.courtId,
                        },
                        price: rent.rentSum || 0,
                        created_at: rent.startTime,
                    });
                });
            }
            
            if (historyData.memberships && Array.isArray(historyData.memberships)) {
                historyData.memberships.forEach((membership: any) => {
                    const membershipName = (membership.membershipName || "").toLowerCase();
                    const isFamilyType = membershipName.includes('семей') || 
                                       membershipName.includes('family') ||
                                       (membership.additionalOwners && membership.additionalOwners.length > 0);
                    
                    const familyUsers = [];
                    if (isFamilyType) {
                        if (membership.partnerName) {
                            familyUsers.push({
                                profile: {
                                    name: membership.partnerName
                                }
                            });
                        }
                        if (membership.additionalOwners && Array.isArray(membership.additionalOwners)) {
                            membership.additionalOwners.forEach((owner: any) => {
                                const ownerName = owner.partnerName || owner.name;
                                if (ownerName) {
                                    const isMainOwner = membership.partnerName && ownerName === membership.partnerName;
                                    if (!isMainOwner) {
                                        familyUsers.push({
                                            profile: {
                                                name: ownerName
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                    
                    const savedPartnerId = membership.partnerId || membership.partner_id;
                    processedHistory.push({
                        ...membership,
                        type: "subscription",
                        id: `membership_${membership.membershipId}_${membership.activationDate}`,
                        membershipId: membership.membershipId,
                        partnerId: savedPartnerId,
                        partner_id: savedPartnerId,
                        subscription: {
                            title: membership.membershipName || "Абонемент",
                            type: isFamilyType ? 'family' : 'adult',
                            includes: membership.includes || "pool,sauna",
                            price: membership.sum || 0,
                        },
                        profile: {
                            name: membership.partnerName || "Пользователь",
                        },
                        date_from_iso: membership.activationDate,
                        date_to_iso: membership.finishDate,
                        expires_at: membership.finishDate,
                        expiration_time: membership.finishDate,
                        bought_at: membership.activationDate,
                        price: membership.sum || 0,
                        isDiscountPeriod: membership.isDiscountPeriod || false,
                        additionalOwners: membership.additionalOwners || [],
                        family: familyUsers.length > 0 ? familyUsers : undefined,
                    });
                });
            }
            
            return processedHistory;
        } catch (error) {
            throw error;
        }
    }
);
